"use client";

import { CalendarSearch } from "lucide-react";
import { useTranslations } from "next-intl";

export default function LedgerDateRangeEmptyState() {
  const t = useTranslations("ledger");

  return (
    <div className="flex flex-col items-center text-center px-4 py-10 gap-3">
      <div className="flex items-center justify-center rounded-full bg-brand-primary/10 size-14">
        <CalendarSearch className="size-7 text-brand-boundary" />
      </div>
      <h3 className="text-lg font-semibold text-gray-900">
        <span>{t("noRecentActivityExplainer")}</span>
      </h3>
    </div>
  );
}
